/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import Config from '@/config'

export function cms () {
  return {
    namespaced: true,
    state: {
      meta: {
        title: '',
        description: '',
        abstract: '',
        keywords: '',
        meta_robots: ''
      },
      content: null,
      contents: {},
      ssrIDS: [], // all IDS of content loaded by the server
      hasHero: false,
      videoModalUrl: false,
      styleLib: Config.API.cms.styleLib,
      currentComponent: '',
      blogParentCat: null,
      blogCurrCat: null,
      blogPost: {}
    },
    getters,
    actions,
    mutations
  }
}
